import { createFileRoute } from "@tanstack/react-router";
import { ProductsPage } from "@/components/blocks/products/ProductsPage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/produits")({
	component: ProductsPage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("products", loaderData.locale, {
					structuredData: [
						buildPageBreadcrumb(loaderData.locale, ["products"]),
					],
				})
			: {},
});
